<template>
    <div class="animated fadeIn">
        <b-card-body>
            <b-row>
                <b-col align="right" md="10">
                </b-col>
                <b-col align="right" md="2">
                    <b-button type="button" variant="success"  @click='clickCreateCustomer()'><i class="fa fa-add"></i> Создать заказчика</b-button>
                    <br><br>
                </b-col>
            </b-row>
        </b-card-body>

        <v-server-table :url="apiurl('customer/table')"  :columns="columns" :options="options" :theme="theme" id="customersTable" ref="customersTable"   class="table table-sm">
            <span slot="name" slot-scope="props" >
                {{ customerTitle(props.row) }}
                <br><small>{{ customerSubtitle(props.row) }}</small>
            </span>

            <router-link :to="{ path: '/agent/customer/'+props.row.id }" slot="cmd_edit" slot-scope="props" >
                <i class="fa fa-edit fa-lg text-primary"></i>
            </router-link>

            <!--
                        <a href="#" slot="m_disabled" slot-scope="props" @click.prevent="disable(props.row, !!props.row.m_disabled)"  >
                            <i class="fa fa-lg fa-play-circle-o text-success" v-if="!props.row.m_disabled"></i>
                            <i class="fa fa-lg fa-pause-circle-o text-danger" v-if="!!props.row.m_disabled"></i>
                        </a>


                        <a href="#" slot="login_as" slot-scope="props" @click.prevent="loginAs(props.row.id)" v-if="is_god">
                            <i class="icon-login text-primary"></i>
                        </a>

                        <span slot="role" slot-scope="props" >
                            {{ roles[props.row.role_id] }}
                        </span>

                        <span slot="image" slot-scope="props" >
                            <img :src="props.row.image" alt="" />
                        </span>
            -->
        </v-server-table>

        WID=fc82ffaa-306a-4000-835c-fff80afc03b1

    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_customers } from '@/functions_customers.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_vouchers_view } from '@/functions_vouchers_view.js';
    import {CONSTANTS} from '@/constants';
    Vue.use(ServerTable)

    export default {
        name: 'NsbAgentCustomers',
        components: { ServerTable, Event,  },
        mixins: [functions, functions_loaders, functions_vouchers_view, functions_customers, functions_company],
        data: function () {
            return {
                columns:[ 'id', 'name', 'disabled', 'banned', 'cmd_edit'],
                options:{
                    saveState: true,
                    headings: {
                        id: '#',
                        name: 'ФИО',
                        // company: 'компания',
                        // phone_mobi: 'телефоны',
                        // role: 'роль',
                        // local_phone_stat: 'местный тел.',
                        // login_as: function(h) { return (
                        //     <i class="icon-login" title="залогиниться как пользователь"></i>
                        // )},
                        cmd_edit: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование заказчика"></i>
                        )},
                        // m_disabled: function(h) { return (
                        //     <i class="fa fa-pause-circle-o fa-lg" title="включение/отключенные компании"></i>
                        // )}
                    },
                    sortable: ['id', 'name', ],
                    filterable: ['id', 'name', ],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: { chunk: 10, edge: false, nav: 'scroll', dropdown:false },
                    templates: {
                    },
                    customFilters: [
                    ],
                    perPage:20,
                    perPageValues:[],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    columnsClasses: {
                        m_disabled: "center",
                        cmd_edit: "center",
                    },
                },
                theme: 'bootstrap4',
                template: 'default'
            }
        },
        methods: {
            disable: function(user, state) {
                if (state) {
                    this.enableCustomer(user.id, function() {
                        user.m_disabled = 0;
                    })
                }
                else {
                    this.disableCustomer(user.id, function() {
                        user.m_disabled = 1;
                    })
                }
            },
            saveFilter() {
                this.$store.commit('saveFilters', {
                    activeFilter:this.activeFilter,
                });
            },
            restoreFilter() {
                this.activeFilter = this.$store.state.filters.activeFilter;
                if (!this.activeFilter) this.activeFilter=null;

                let table = this.$refs.usersTable;
                table.page = 1;
                table.$refs.pagination.Page = 1;
                table.customQueries.company = this.companyFilter;
                table.customQueries.active = this.activeFilter;
                table.getData();
            },
            clickCreateCustomer: function() {
                this.httpPrepare();
                this.$http.post(this.apiurl('customer/create')).then(function (response) {
                    response = this.httpSuccess(response);
                    console.log(response)
                    this.$router.push({path: '/agent/customer/'+response.payload});
                }, this.httpError)
            },

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                        CLIENT                                                              //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



        },
        computed: {

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        }
    }
</script>
